import chroma from 'chroma-js';

export function generatePalette(baseColor: string) {
    const base = chroma(baseColor);
    return {
        50: base.set('hsl.l', 0.96).saturate(0.6).hex(),
        100: base.set('hsl.l', 0.92).saturate(0.7).hex(),
        200: base.set('hsl.l', 0.85).saturate(0.8).hex(),
        300: base.set('hsl.l', 0.75).saturate(0.9).hex(),
        400: base.set('hsl.l', 0.65).saturate(1).hex(), 
        500: baseColor,
        600: base.set('hsl.l', 0.45).hex(),
        700: base.set('hsl.l', 0.35).hex(),
        800: base.set('hsl.l', 0.25).hex(),
        900: base.set('hsl.l', 0.15).hex(),
        950: base.set('hsl.l', 0.10).hex(),
    };
}

export function hexToRgb(hex: string): string {
    hex = hex.replace(/^#/, '');
  
    // Convierte HEX de 3 dígitos a 6
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
  
    // Parsea a valores R, G, B
    const num = parseInt(hex, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
  
    return `${r}, ${g}, ${b}`;
}